var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{staticClass:"aroma-secondary-nav",attrs:{"title":_vm.title,"left-arrow":"","fixed":"","placeholder":""},on:{"click-left":_vm.goBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }